<template>
  <div>
    <div v-if="visible" class="fixed inset-0 z-[10000] grid place-items-center bg-black text-[var(--on-overlay-text)]">
      <div class="flex w-[min(480px,90vw)] flex-col items-center gap-5">
        <img :src="brandLogoDark" alt="CardGenius" class="h-10 w-auto object-contain sm:h-12" />
        <div class="h-px w-full overflow-hidden rounded bg-white/15">
          <span class="app-entry-splash__line block h-full w-1/3 bg-white/70" />
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import brandLogoDark from "@/assets/branding/Full/Dark.svg";

const visible = ref(true);
let timeout: number | null = null;

onMounted(() => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  timeout = window.setTimeout(() => {
    visible.value = false;
  }, prefersReducedMotion ? 700 : 2200);
});

onBeforeUnmount(() => {
  if (timeout !== null) {
    window.clearTimeout(timeout);
  }
});
</script>

<style scoped>
.app-entry-splash__line {
  animation: splash-line 1.6s ease-in-out infinite;
}

@keyframes splash-line {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(340%);
  }
}
</style>
